import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('CaseCard').create(({ theme }) => ({
  root: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'flex-start',
    gap: '8px',
    width: '100%',
    padding: '16px',
    height: '120px',
    backgroundColor: theme.colors.button.secondary.background,
    border: '1px solid',
    borderColor: theme.colors.borders.secondary,
    borderRadius: '12px',

    '&[data-isavailable="false"]': {
      opacity: '0.5',
      pointerEvents: 'none',
    },
  },
  imageWrapper: {
    position: 'relative',
    width: '100px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  caseImage: {
    position: 'absolute',
    width: '125%',
    zIndex: '1',
    transform: 'translateX(-6px)',
  },

  icon: {
    position: 'absolute',
    left: '3%',
  },

  caseNameSubnameWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  textAndButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    marginRight: '12px',
  },

  caseTitle: {
    textAlign: 'left',
    fontSize: '19px',
    textWrap: 'wrap',
    lineHeight: '24px',
    fontWeight: 450,
    color: theme.colors.text.primary,
  },

  subNameWrapper: {
    display: 'flex',
  },
  buttonWrapper: {
    position: 'relative',
    top: '4px',
    display: 'flex',
    justifyContent: 'flex-start',
  },

  caseSubName: {
    fontSize: '14px',
    lineHeight: '14px',
    fontWeight: 350,
    color: theme.colors.text.primary,
  },

  openButton: {
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(77, 78, 83, 1)',
    borderRadius: '28px',
    padding: '4px 12px',
    gap: '8px',
  },
}))
